import React from 'react'
import { CircularProgress } from '@material-ui/core'
import TotalState from './TotalState'
import TableHeader from './TableHeader'
import Typography from "@material-ui/core/Typography";

const mobile = window.innerWidth < 720;

const getMonthName = (month) => {
    if (month === '01') return 'янв';
    if (month === '02') return 'фев';
    if (month === '03') return 'мар';
    if (month === '04') return 'апр';
    if (month === '05') return 'май';
    if (month === '06') return 'июн';
    if (month === '07') return 'июл';
    if (month === '08') return 'авг';
    if (month === '09') return 'сен';
    if (month === '10') return 'окт';
    if (month === '11') return 'ноя';
    if (month === '12') return 'дек';
};

const Schedule = (props) => {
    const { tableTemplate, schedule, loading, days, tSes, dates } = props;

    let header = (
        <tr>
            <th align="center" rowSpan={2} style={{width: 25, fontWeight: 500, position: 'sticky', top: 0, backgroundColor: '#fff'}}>№</th>
                {dates.map(value => (
                    value === 'Врач' ?
                        <th align="center" rowSpan={2} colSpan={tSes === 'all-detail' ? 3 : 2} style={{width: 500, fontWeight: 500, position: 'sticky', top: 0, backgroundColor: '#fff'}}>
                            {value}
                        </th> :
                        <th align="center" style={{fontWeight: 500, position: 'sticky', top: 0, backgroundColor: '#fff'}}>
                            <div style={{height: 21}}>
                                {(window.innerWidth < 1660 || days > 14) ? value.substring(0,2) + ' ' + getMonthName(value.substring(3,5)) : value }
                            </div>
                        </th>
                ))}
            </tr>
    );

    return (
        <div>
            <TotalState records={tSes !== 'all' && tSes !== 'all-detail' ? schedule.slice().filter(row => row.pers === tSes) : schedule.slice()} setColor={props.setColor}/>
            <div style={{height: 30, marginLeft: '5%'}}>
                <div style={{float: 'left', marginRight: 10}}>
                    <div style={{width: 30, height: 20, backgroundColor: '#4caf50', float: 'left'}}/>
                    <span style={{marginLeft: 10}}>{' более ' + props.green + '% свободных записей'}</span>
                </div>
                <div style={{float: 'left', marginRight: 10}}>
                    <div style={{width: 30, height: 20, backgroundColor: '#ff9800', float: 'left'}}/>
                    <span style={{marginLeft: 10}}>{' менее ' + props.green + '% свободных записей'}</span>
                </div>
                <div style={{float: 'left', marginRight: 10}}>
                    <div style={{width: 30, height: 20, backgroundColor: '#f44336', float: 'left'}}/>
                    <span style={{marginLeft: 10}}>{' ' + props.red + '% свободных записей'}</span>
                </div>
            </div>
            <div style={{margin: '10px 5% 0 5%', overflow: 'auto', position: "absolute", top: 260, bottom: 0, width: "90%"}}>
                {loading ? (
                    <CircularProgress style={{marginLeft: '50%', marginTop: window.innerHeight/3}}/>
                ) :
                    schedule.length ? (
                        <table border={1} borderColor={"#eeeeee"} cellPadding={5} cellSpacing={0} style={{ width: !mobile ? "100%" : 1300, tableLayout: 'fixed', fontSize: !mobile ? 'inherit' : 8 }}>
                            <col/>
                            <col style={{width: !mobile ? 180 : 120}} />
                            <col style={{width: !mobile ? (tSes === 'all-detail' ? 150 : 70) : 40}} />
                            {tSes === 'all-detail' ? <col style={{width: 70}} /> : <col/>}
                            <thead>
                            {header}
                            <TableHeader records={tSes !== 'all' && tSes !== 'all-detail' ? schedule.slice().filter(row => row.pers === tSes) : schedule.slice()} dates={dates} setColor={props.setColor}/>
                            </thead>
                            <tbody>
                            {tableTemplate}
                            </tbody>
                        </table>
                    ) : (
                        <Typography variant={"headline"} align={"center"} style={{marginTop: window.innerHeight/3}}>
                            {'Нет данных для отображения'}
                        </Typography>
                    )
                }
            </div>
        </div>
    )
};

export default Schedule;